<form [formGroup]="form" (ngSubmit)="onSubmit()">
  @for (field of formModel.formFields; track field) {
    <div class="row">
      <loren-entity-form-field
        [fullLength]="fullLengthFields"
        [field]="field"
        [isHandset]="isHandset$ | async"
        [formGroup]="form"
        (formFieldInteraction)="handleFormFieldInteraction($event)"
        >
      </loren-entity-form-field>
    </div>
  }
  @if (showErrors && formErrors.length > 0) {
    <div class="mt-1 mb-3">
      <ul class="pl-3">
        @for (error of formErrors; track error) {
          <li
            [innerHTML]="error"
            class="warn"
          ></li>
        }
      </ul>
    </div>
  }
</form>
